import GoogleForm from "../../../components/common/GoogleForm/GoogleForm";
import "./Contact.css";

import { formatPhone } from "../../../utils/formFormatters";

import { FiAlertTriangle } from "react-icons/fi";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaCommentDots,
} from "react-icons/fa";

const CONTACT_FORM_FIELDS = [
  {
    name: "name",
    googleName: "entry.1810036937",
    label: "Nome Completo",
    type: "text",
    placeholder: "Digite seu nome completo",
    required: true,
    icon: FaUser,
    autoComplete: "name",
  },
  {
    name: "email",
    googleName: "entry.1399125045",
    label: "Email",
    type: "email",
    placeholder: "seu.email@exemplo.com",
    required: true,
    icon: FaEnvelope,
    autoComplete: "email",
  },
  {
    name: "phone",
    googleName: "entry.179238990",
    label: "Telefone",
    type: "tel",
    placeholder: "(00) 00000-0000",
    required: true,
    maxLength: 15,
    icon: FaPhoneAlt,
    autoComplete: "tel",
    format: formatPhone,
  },
  {
    name: "message",
    googleName: "entry.1884742960",
    label: "Mensagem",
    type: "textarea",
    placeholder: "Conte-nos como podemos ajudá-lo...",
    required: true,
    rows: 5,
    icon: FaCommentDots,
  },
];

const Contact = () => {
  return (
    <section id="contato" className="contact section">
      <div className="container">
        <div className="contact-content">
          <div className="contact-intro">
            <h2 className="contact-title">
              Entre em contato
              <br />
              conosco
            </h2>

            <p className="contact-description">
              Estamos prontos para entender suas necessidades e encontrar a
              melhor solução para você.
            </p>

            <div className="disclaimer">
              <div className="disclaimer-item">
                <FiAlertTriangle />

                <p>
                  <strong>Atenção: a Egel não realiza empréstimos pessoais.</strong>{" "}
                  Atuamos na intermediação de crédito consignado e outros
                  serviços disponíveis em nosso site.
                </p>
              </div>

              <div className="disclaimer-item">
                <FiAlertTriangle />

                <p>
                  <strong>Lembre-se: </strong>
                  O contato com a Egel é gratuito e não obriga à
                  contratação.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper form-panel">
            <GoogleForm
              formUrl="https://docs.google.com/forms/d/e/1FAIpQLSdiBbVqQ2rIFSMq8XTu2_z0Rx1wxsxCaocEFBPAb1Diu3PvYQ/formResponse"
              notifyUrl="https://formsubmit.co/ajax/fernando@egelemprestimos.com.br"
              emailSubject="Novo contato via site"
              fields={CONTACT_FORM_FIELDS}
              submitText="Mandar Mensagem"
              sendingText="Enviando..."
              successMessage="Mensagem enviada com sucesso!"
              receivedMessage="Mensagem recebida! Entraremos em contato em breve."
              className="contact-form"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;